import React from "react";

import AreaStatsModel from "./AreaStatsModel";
import Context from "../../../context/Context";
import GraphicStat from "./GraphicStat";
import OfficePlan from "../../base/OfficePlan";
import Topic from "../../../context/Topic";
import * as component from "../../../components/util/component";

import {
  StatsWrapper,
  GroupIcon,
  MeasureAreaIcon,
  PersonIcon
} from "../../styles/statsStyles";

export default class AreaStats extends React.Component {
  model;

  _mounted = false;

  constructor(props) {
    super(props);
    this.state = component.newState({
      peopleCount: 0,
      unitCount: 0,
      sumArea: 0,
      sumCapacity: 0
    });
    this.model = new AreaStatsModel({});
  }

  componentDidMount() {
    this._mounted = true;
    this.refreshStats();

    component.own(this, [
      Topic.subscribe(Topic.PlanModified, params => {
        const actions = [OfficePlan.Action_AssignmentsUpdated];
        if (actions && actions.indexOf(params.action) !== -1) {
          this.refreshStats();
        }
      })
    ]);
  }

  componentWillUnmount() {
    component.componentWillUnmount(this);
    this._mounted = false;
  }

  refreshStats = () => {
    const areaItem = this.props.areaItem;
    const areaType = this.props.areaType;
    this.model
      .queryStats(areaItem, areaType)
      .then(result => {
        //console.log("AreaStats.queryStats",result)
        if (!this._mounted) return;
        this.setState({
          peopleCount: result.peopleCount,
          unitCount: result.unitCount,
          sumArea: result.sumArea,
          sumCapacity: result.sumCapacity
        });
      })
      .catch(ex => {
        console.warn("Error refreshing area stats for", areaItem);
        console.error(ex);
      });
  }

  render() {
    const i18n = Context.instance.i18n;
    const lib = Context.instance.lib;
    let peopleCount = this.state.peopleCount;
    //let unitCount = this.state.unitCount;
    let sumArea = this.state.sumArea;
    let sumCapacity = this.state.sumCapacity;

    if (typeof peopleCount !== "number") peopleCount = 0;
    if (typeof sumArea !== "number") sumArea = 0;
    if (typeof sumCapacity !== "number") sumCapacity = 0;
    if (typeof sumArea === "number") {
      sumArea = lib.dojo.number.format(sumArea, { places: 0 });
    }

    let peopleDanger = false;
    if (sumCapacity > 0 && peopleCount > sumCapacity) peopleDanger = true;

    // let utilization = null; // 50% Utilization
    // let utilizationDanger = false;
    // if (typeof peopleCount === "number" && typeof sumCapacity === "number" && sumCapacity > 0) {
    //   utilization = ((peopleCount / sumCapacity) * 100);
    //   utilization = lib.dojo.number.format(utilization, {places: 0});
    //   if (utilization > 100) {
    //     utilizationDanger = true;
    //   }
    //   utilization = i18n.spaceplanner.stats.percentPattern.replace("{num}",utilization);
    // } else {
    //   utilization = 0;
    //   if (peopleCount > 0) {
    //     utilization = i18n.spaceplanner.stats.greaterThan100Percent;
    //     utilizationDanger = true;
    //   }
    // }

    return (
      <StatsWrapper key="a" className="i-areastats-graphics">
        <GraphicStat
          key="sumCapacity"
          icon={<GroupIcon />}
          label={i18n.spaceplanner.areaStats.capacity}
          value={sumCapacity}
        />
        <GraphicStat
          key="people"
          icon={<PersonIcon />}
          label={i18n.spaceplanner.areaStats.people}
          value={peopleCount}
          danger={peopleDanger}
        />
        <GraphicStat
          key="sumArea"
          icon={<MeasureAreaIcon />}
          label={i18n.spaceplanner.areaStats.area}
          value={sumArea}
        />
      </StatsWrapper>
    );
  }
}
